<template>
    <div class="wrapper">
        <skeleton-wrapper :is-loading="loading">
            <template v-slot:skeleton>
                <service-list-skeleton />
            </template>
            <template v-slot:content>
                <div class="row justify-content-center" v-if="existStreams || existPrograms">
                    <div :class="['col-12', textColor, textAlign]">
                        <h4 class="h4">{{ title }}</h4>
                        <p v-if="description">{{ description }}</p>
                    </div>
                </div>
                <service-list-stream 
                    v-if="existStreams"
                    :streams="streams" 
                    :totalStreams="streams.length"
                    :showCarousel="showCarousel(streams, 1, 2, 3)"
                    @onAction="trackServiceEvent"
                />
                <service-list-program 
                    v-if="existPrograms"
                    :programs="programs"
                    :showCarousel="showCarousel(programs, 1, 1, 2)"
                    @onAction="trackServiceEvent"
                />
            </template>
        </skeleton-wrapper>
    </div>
</template>

<script>
    import mobileCheckMixin from "../mixins/mobileCheckMixin";
    import ServiceListStream from '../organisms/ServiceListStream';
    import ServiceListProgram from '../organisms/ServiceListProgram';
    import SkeletonWrapper from "../organisms/SkeletonWrapper";
    import ServiceListSkeleton from "../molecules/skeletons/ServiceListSkeleton";

    export default {
        name: "ServiceList",
        components: { ServiceListStream, ServiceListProgram, SkeletonWrapper, ServiceListSkeleton },
        props: {
            title: String,
            description: String,
            textColor: String,
            textAlign: String,
            mountLocation: {
                required: true,
                type: String
            }
        },
        data() {
            return {
                programs: [],
                streams: [],
                loading: true
            }
        },
        mounted() {
            this.fetchServices();
            trackEvent('ServiceListView', {
                location: this.mountLocation
            })
        },
        computed: {
            existStreams(){
                return this.streams.length > 0;
            },
            existPrograms(){
                return this.programs.length > 0;
            }
        },
        methods: {
            showCarousel(services, carouselSlidesMobile, carouselSlidesTablet ,carouselSlidesDesktop){
                if(((services.length > carouselSlidesMobile) && this.isMobile) 
                    || ((services.length > carouselSlidesTablet) && this.isTablet)
                    || ((services.length > carouselSlidesDesktop) && !this.isTablet))
                    return true;
                
                return false;
            },
            async fetchServices(){
                return this.$axios.get(`/api/rest/services`)
                    .then(res => {
                        const services = res.data;
                        this.programs = services.hasOwnProperty('programs') ? services.programs : [];
                        this.streams = services.hasOwnProperty('streams') ? services.streams : [];
                        if(this.programs.length > 0){
                            this.programs.sort((m1, m2) => m2.highlight - m1.highlight);
                        }

                        this.loading = false;

                        this.$emit('serviceListCount', this.programs.length + this.streams.length);
                    })
                    .catch(err => {
                        this.loading = false;
                        console.log(err);
                    });
            },
            trackServiceEvent(actionData){
                const actionName = actionData.actionType === 'access' ? 'ChooseService' : 'MoreInfo';
                trackEvent(`ServiceList${actionName}`,{
                    serviceType: actionData.serviceType, 
                    serviceId: actionData.serviceId,
                    location: this.mountLocation
                });
            },
        },
        mixins:[mobileCheckMixin]
    }
</script>

<style lang="scss" scoped>
    .wrapper {
        min-height: 400px;
    }
</style>